<template>
    <pg-page title="Private Gym - Veelgestelde vragen"
             header=""
             id="faq"
    >

        <section class="accordion-section clearfix mt-3" aria-label="Question Accordions">
            <div class="container">

                <h1>Veelgestelde vragen</h1>

                <div class="input-group mb-3">
                    <span class="input-group-text">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                    <input v-model="query" type="text" class="form-control" placeholder="Zoek binnen de vragen en antwoorden">
                </div>


                <div class="mt-4 pt-3">
                    <h2>Personal Training</h2>

                    <div class="accordion">
                        <accordion-item :query="query">
                            <template v-slot:title>Wat zijn de mogelijkheden op personal training gebied?</template>
                            <template v-slot:text>Afhankelijk van jouw behoefte plannen we  een Personal Training sessie in. Dit kan 1x per 6 weken zijn, maar ook 1x per 4 weken of wekelijks. Weet je niet wat voor jou passend zou zijn dan kun je dit samen met onze trainers overleggen.
                                <br/><br/>
                                We kijken dan samen naar je doelen, je wensen, en bieden indien gewenst een op maat gemaakt traject. Dat hoeft zich niet alleen te beperken tot sporten. Ook bij mindset en voeding kunnen we je helpen!
                            </template>
                        </accordion-item>
                    </div>
                </div>


                <div class="mt-4 pt-3">
                    <h2>Abonnementen</h2>

                    <div class="accordion">
                        <accordion-item :query="query">
                            <template v-slot:title>Waarom is Private Gym zo duur? Kan ik korting krijgen?</template>
                            <template v-slot:text>
                                Prijs is relatief. Voor de service die wij bieden, is het zelfs goedkoop. Helaas is de perceptie
                                van de waarde van sport enorm gekelderd met de komst van de massa ketens. Twee tientjes per maand,
                                da's de baseline geworden. Maar <em>you get what you pay for</em>. Goede service, fijne begeleiding,
                                tijd voor jou. Een rustige gym - dat kost iets. Maar daar krijg je ook wat voor terug.
                                <br/>
                                <br/>
                                We vinden het heel normaal om €100 bij een restaurant in 2/3 uur stuk te slaan. Maar 4 weken lang onbeperkt
                                kunnen trainen, daar begeleiding bij krijgen - dat is dan duur. Wij dagen je uit: investeer in jezelf.
                                Ga voor die doelen. Fitter worden. Slanker, gespierder, gezonder. Dan investeren wij met je mee! Zijn er voor je. Helpen je bij fitness voor het lichaam, <em>en</em> de geest. Bij Private Gym
                                willen we namelijk <em>wel</em> dat je naar de gym komt.
                            </template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Is mijn abonnement maandelijks opzegbaar?</template>
                            <template v-slot:text>Bij een looptijd van één maand wel. Bij een looptijd van 12 maanden is je abonnement na die 12 maanden maandelijks opzegbaar.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Wanneer wordt mijn abonnement afgeschreven?</template>
                            <template v-slot:text>Om de 4 weken door middel van automatische incasso. Of je kan kiezen voor een vaste datum in de maand.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Kan ik mijn abonnement tijdelijk pauzeren?</template>
                            <template v-slot:text>Jazeker, als je langdurig geblesseerd bent, een operatie moet onderdaan of zwanger bent waardoor je tijdelijk even niet kunt sporten zetten we je abonnement graag even op pauze voor je.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Mag ik mijn lidmaatschap met iemand delen?</template>
                            <template v-slot:text>Nee, je krijgt wel duo korting als je samen met een vriend / vriendin / familielid sport. Ook als één van jullie twee zich pas later inschrijft. Account sharing mag niet.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Als het onbeperkt trainen is, waarom werken jullie dan wel met credits?</template>
                            <template v-slot:text>Om te voorkomen dat iemand een hele week vol plant en alleen op komt dagen wanneer het diegene past. Dan blokkeer je de mogelijkheden voor anderen. Mocht je credits tekort komen, vullen we die graag weer handmatig voor je aan.</template>
                        </accordion-item>
                    </div>
                </div>


                <div class="mt-4 pt-3">
                    <h2>De Eilanden</h2>

                    <div class="accordion">
                        <accordion-item :query="query">
                            <template v-slot:title>Ik ben gewend te trainen met apparaten, kan dat bij jullie ook?</template>
                            <template v-slot:text>
                                Nee, met reden. Krachttraining apparaten trainen zeer geïsoleerd je spieren. Alle balans spieren eromheen, die blijven slap. De kracht die je dan ervaart op zo'n apparaat, zal zich niet vertalen naar kracht buiten de gym. Door te trainen met vrije gewichten train je <em>al</em> je spieren. Voor een fitter, sterker lijf.
                                <br/>
                                <br/>
                                Maar het kan even wennen zijn. No worries! Wij helpen je met de transitie. Doormiddel van de techniek training en coaches die rondlopen, ben je in no-time functioneel aan het trainen, en hard op weg je doelen te behalen.
                            </template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Kan ik ook mijn conditie trainen?</template>
                            <template v-slot:text>
                                Zeker! We hebben cardio apparaten staan, maar vergeet ook de kettlebells en circuits niet! Geef je wensen aan bij een van de trainers en wij helpen je aan een passend schema met oefeningen. Dan gaat je conditie in no-time met sprongen vooruit.
                            </template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Hoe werkt zo'n power rack?</template>
                            <template v-slot:text>
                                Dat gaan we je uitleggen ;-) Een Power Rack combineert tientallen "apparaten" in één. Waarmee je iedere spiergroep mee kunt trainen. We hebben ook videos van oefeningen waardoor je ook zonder trainer altijd je weg kunt vinden.
                            </template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Hoe lang kan ik een eiland reserveren?</template>
                            <template v-slot:text>30, 60, 90 of 120 minuten, op het hele en het halve uur.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Is er een mogelijkheid om een eiland te kiezen?</template>
                            <template v-slot:text>Jazeker, je kunt altijd je favoriete eiland kiezen, mits deze nog beschikbaar is op dat tijdstip. Zo niet, zijn er genoeg tijden of eilanden wel vrij in een 24/7 gym ;-)</template>
                        </accordion-item>
                    </div>
                </div>


                <div class="mt-4 pt-3">
                    <h2>Credits & reserveren</h2>

                    <div class="accordion">
                        <accordion-item :query="query">
                            <template v-slot:title>Mag ik samen met iemand op het eiland trainen?</template>
                            <template v-slot:text>Dat kan, het is jouw eiland! Maar hou rekening met de buren. Dat het geen theekransjes worden ;-)</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Tot welk moment kan ik mijn reservering annuleren zonder dat het een credit kost?</template>
                            <template v-slot:text>Als je tijdslot meer dan 24 uur in de toekomst ligt krijg je automatisch je credit terug.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Hoe ver van tevoren kan ik een eiland reserveren?</template>
                            <template v-slot:text>Dit kan met het standaard abonnement tot 7 dagen in de toekomst.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Vanaf welke tijd kan ik de gym in als ik gereserveerd heb?</template>
                            <template v-slot:text>Je kan 20 minuten voor je gereserveerde tijdslot de deur open doen. Zo heb je meer dan genoeg tijd om om te kleden, je spullen in een kluisje te leggen, en je bidon te vullen. Mocht je eiland al vrij zijn, kun je direct sporten!</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Wat als er iets gebeurt, en ik ben alleen?</template>
                            <template v-slot:text>Je kan de gym niet in zonder telefoon, dus je kunt altijd ons, een instantie of iemand anders bellen. Verder kan er niemand in de gym die geen lid is, en die we niet persoonlijk kennen.<br/><br/>Daarnaast hebben we ook een camera systeem die alle hoeken van de gym 24/7 monitored voor jouw veiligheid. Het is daarom wel belangrijk dat je niemand zomaar binnen laat. Voor je eigen veiligheid, en die van anderen.</template>
                        </accordion-item>
                    </div>
                </div>


                <div class="mt-4 pt-3">
                    <h2>Algemeen</h2>

                    <div class="accordion">
                        <accordion-item :query="query">
                            <template v-slot:title>Wanneer zijn jullie open?</template>
                            <template v-slot:text>24/7! 7  dagen per week.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Kan ik m'n fiets ergens aan vast zetten?</template>
                            <template v-slot:text>Nee helaas, maar een goed slot doet wonderen! En anders is er om de hoek een fietsen parkeerplek.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Kan ik mijn auto ergens parkeren?</template>
                            <template v-slot:text>Jazeker, er zit een grote openbare garage achter de gym.</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Mag ik me wel inschrijven bij Private Gym?</template>
                            <template v-slot:text>Gek genoeg denken sommigen dat Private Gym hoort bij het appartementen complex boven de gym. Geenszins - Private Gym is voor iedereen met een abonnement toegankelijk!</template>
                        </accordion-item>
                        <accordion-item :query="query">
                            <template v-slot:title>Zijn er douches?</template>
                            <template v-slot:text>
                                Zeker. We hebben een douche, een WC, een pantry en gevulde koelkast.
                            </template>
                        </accordion-item>
                    </div>
                </div>
            </div>

        </section>

        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Meer vragen?
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="false" rondleiding-text="Plan een rondleiding" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import AccordionItem from "../Components/Faq/AccordionItem";
import ActionButtons from "../Components/Index/ActionButtons";
export default {
    components: {
        ActionButtons,
        AccordionItem,
        PgPage
    },

    props: [],

    mixins: [],

    data: function () {
        return {
            // showFormModal: false,
            query: '',
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
